/**
 * Suspense fallback shown while a code-split route chunk resolves
 * (task 106 §1.2). It reuses the identity of the inline HTML splash from
 * §1.1 — a calm, centered brand mark on the canvas — so the hand-off from
 * the eager shell to a lazily-loaded page reads as one continuous surface
 * instead of a flash of empty content. Wired as the router's
 * `defaultPendingComponent`, so it renders inside the AppShell content area
 * (chrome stays put) for authenticated routes. The pulse is motion-safe.
 *
 * Matches patterns.md §Айдентика — the mark comes from `<BrandLockup>`, never
 * an ad-hoc `<img>`.
 */
import { useTranslation } from "react-i18next";
import { BrandLockup } from "@/components/brand/BrandLockup";

export function RouteFallback(): React.ReactElement {
  const { t } = useTranslation();
  return (
    <div
      className="flex h-full min-h-[50vh] w-full items-center justify-center bg-[var(--bg-canvas)]"
      role="status"
      aria-label={t("common.loading")}
    >
      <BrandLockup markOnly size={56} className="motion-safe:animate-pulse" />
    </div>
  );
}
